import cx from 'classnames';
import { isAuthenticated } from 'mk/bazaar/common/userUtils';
import { ACTIVE_SERVER_ID } from 'mk/settings';
import { about_privacy_and_cookie_policy_pattern } from 'mk/urls/patterns';
import { BrandDaysCampaignEntity } from 'mk2/apps/forum/schemas';
import { hasMergedForumAndGroups } from 'mk2/apps/forum/utils';
import { loginUrl, signupUrl } from 'mk2/apps/users/urls';
import Header from 'mk2/components/Header';
import Link from 'mk2/components/Link';
import NotificationMenu from 'mk2/components/NotificationMenu';
import PrivacyReminder from 'mk2/components/PrivacyReminder';
import { pageHeaderFetchFlaggedCountsTrigger, pageHeaderLoad } from 'mk2/containers/PageHeader/PageHeader.action';
import { MenuItem } from 'mk2/containers/PageHeader/PageHeader.reducers';
import { privacyLeafletAcceptTrigger } from 'mk2/containers/PrivacyReminder/PrivacyReminder.actions';
import { DesktopHeader } from 'mk2/containers/SiteMenu/DesktopHeader';
import styles from 'mk2/containers/SiteMenu/SiteMenu.mscss';
import Loadable from 'mk2/helpers/Loadable';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import {
    AppState,
    getPageHeaderState,
    getRequestDeviceMobile,
    getRequestPermissions,
    getRequestPrivacyLeaflet,
    getRequestUser,
} from 'mk2/reducers';
import { MenuSelection, SubscribedCounsellingsCounts, UserEntity } from 'mk2/schemas';
import { subscribeJam, unsubscribeJam } from 'mk2/services/jam';
import { parse, stringify } from 'query-string';
import React from 'react';
import { connect } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import { Sticky } from 'react-sticky';
import { CSSTransition } from 'react-transition-group';

/* UserMenu is displayed on user interaction - so we can code split it safely */
const MobileMenu = Loadable({
    loader: () => import('mk2/components/MobileMenu' /* webpackChunkName: "components.MobileMenu" */),
    modules: ['mk2/components/MobileMenu'],
    webpack: () => [ require.resolveWeak('mk2/components/MobileMenu') ],
});

interface OwnState {
    mobileMenuOpened: boolean;
}

interface OwnProps {
    menuSelection?: MenuSelection;
    fluxibleCompatibility: boolean;
    currentUrl: string;  // nemozeme pouzit withRouter(), ten nefunguje v bazari
    isHeaderSticky: boolean;
    dummySticky?: boolean;
    mobileShowLogo?: boolean;
    headerHasBackBtn?: boolean;
    headerTitle?: React.ReactNode;
    headerLeft?: React.ReactNode;
    headerRight?: React.ReactNode;
    headerTabs?: JSX.Element[];
    mergedForumAndGroups?: boolean;

    disableToastr?: boolean;
    disablePrivacyReminder?: boolean;
    disableLogoLink?: boolean;
    disableDesktopSectionTabs?: boolean;
    disableDesktopNotificationMenu?: boolean;
    disableMobileHamburger?: boolean;
    desktopHeaderRight?: React.ReactNode;

    disableJam?: boolean;
}

interface StateProps {
    requestUser: UserEntity;
    requestUserPermissions: string[];
    isMobile: boolean;
    heartsCount: number;
    unreadMails: number;
    newBazaarEvents: number;
    newBazaarSell: number;
    allBazaarSell: number;
    wallStatusNews: number;
    wishlistUpdates: number;
    groupsCount: number;
    subscribedCounsellings: SubscribedCounsellingsCounts;
    brandDaysCampaign: BrandDaysCampaignEntity;
    feedMenu: MenuItem[];
    privacyLeaflet: boolean;
    showMergedForumAndGroups: boolean;
}

interface DispatchProps {
    onLoad(username: string);
    onFetchFlaggedCounts();
    onPrivacyLeafletAccept();
}

type Props = OwnProps & StateProps & DispatchProps;

class SiteMenu extends React.PureComponent<Props, OwnState> {

    private notificationMenu = React.createRef<NotificationMenu>();

    constructor(props: Props) {
        super(props);

        this.state = {
            mobileMenuOpened: false,
        };
    }

    public render() {
        const {
            isMobile, privacyLeaflet, currentUrl, isHeaderSticky, dummySticky, headerTabs,
            fluxibleCompatibility, requestUser, requestUserPermissions, menuSelection,
            heartsCount, unreadMails, newBazaarEvents, newBazaarSell, allBazaarSell,
            wallStatusNews, wishlistUpdates, groupsCount, subscribedCounsellings,
            disableMobileHamburger, disableDesktopSectionTabs, disableDesktopNotificationMenu, disableLogoLink,
            desktopHeaderRight, feedMenu, showMergedForumAndGroups,
        } = this.props;

        if (!isMobile) {
            return (
                <React.Fragment> {/* <div className={styles.SiteMenu}> reduce DOM depth */}
                    {this.renderToastr()}
                    {this.renderPrivacy()}
                    {ACTIVE_SERVER_ID !== 207 && (
                        <DesktopHeader
                            menuSelection={menuSelection}
                            fluxibleCompatibility={fluxibleCompatibility}
                            currentUrl={currentUrl}

                            requestUser={requestUser}
                            requestUserPermissions={requestUserPermissions}
                            isMobile={isMobile}
                            heartsCount={heartsCount}
                            unreadMails={unreadMails}
                            newBazaarEvents={newBazaarEvents}
                            newBazaarSell={newBazaarSell}
                            allBazaarSell={allBazaarSell}
                            wallStatusNews={wallStatusNews}
                            wishlistUpdates={wishlistUpdates}
                            groupsCount={groupsCount}
                            subscribedCounsellings={subscribedCounsellings}
                            notificationMenuRef={this.notificationMenu}
                            onMenuClose={this.menuClose}
                            disableSectionTabs={disableDesktopSectionTabs}
                            disableNotificationMenu={disableDesktopNotificationMenu}
                            disableLogoLink={disableLogoLink}
                            right={desktopHeaderRight}
                            feedMenu={feedMenu}
                            mergedForumAndGroups={showMergedForumAndGroups}
                        />
                    )}
                </React.Fragment>
            );
        } else {
            return (
                <div className={dummySticky ? styles.SiteMenu__mobileDummyStickyContainer : null}>
                    {!disableMobileHamburger && (
                        <React.Fragment>
                            <input className={styles.SiteMenu__mobileMenu__trigger} id="mobileMenuTrigger" checked={this.state.mobileMenuOpened} type="checkbox" onChange={this.onMobileMenuChange} />
                            <label htmlFor="mobileMenuTrigger" className={cx(styles.SiteMenu__mobileOverlay, this.state.mobileMenuOpened && styles['SiteMenu__mobileOverlay--visible'])} />
                        </React.Fragment>
                    )}

                    <div className={cx(styles.SiteMenu__header, dummySticky ? styles.SiteMenu__mobileDummySticky : null)}>
                        {isHeaderSticky ? (
                            <Sticky
                                // force re-render if privacy leaflet is closed, or tabs are shown/hidden
                                key={`render-on-change-of-${privacyLeaflet}-${headerTabs ? headerTabs.length : 0}`}
                            >
                                {({ style }) => (
                                    // top: 0 je pridane, aby header nebol odskoceny, inak ak sa zmeni urlko
                                    // z predchadzajucej stranke moze ostat nastaveny zly top offset
                                    <div style={{...style, top: 0}}>
                                        {this.renderPrivacy()}
                                        {this.renderMobileHeader()}
                                    </div>
                                )}
                            </Sticky>
                        ) : (
                            <React.Fragment>
                                {this.renderPrivacy()}
                                {this.renderMobileHeader()}
                            </React.Fragment>
                        )}
                    </div>

                    {!disableMobileHamburger && this.renderMobileMenu()}
                </div>
            );
        }
    }

    public renderPrivacy() {
        const {
            disablePrivacyReminder, privacyLeaflet, currentUrl, fluxibleCompatibility, onPrivacyLeafletAccept,
        } = this.props;

        const currentPath = currentUrl && currentUrl.indexOf('?') > 0
            ? currentUrl.substr(0, currentUrl.indexOf('?'))
            : currentUrl;
        const ignorePrivacyReminder =
            !!disablePrivacyReminder ||
            ACTIVE_SERVER_ID === 207 ||
            currentPath === about_privacy_and_cookie_policy_pattern ||
            currentPath === loginUrl ||
            currentPath === signupUrl;

        return !ignorePrivacyReminder ? (
            <PrivacyReminder
                fluxibleCompatibility={fluxibleCompatibility}
                currentUrl={currentUrl}
                showPrivacyReminder={!privacyLeaflet}
                onPrivacyLeafletAccept={onPrivacyLeafletAccept}
            />
        ) : null;
    }

    public renderToastr() {
        const { disableToastr } = this.props;

        return !disableToastr ? (
            <ReduxToastr
                position="top-center"
                transitionIn="fadeIn"
                transitionOut="fadeOut"
            />
        ) : null;
    }

    public renderMobileHeader() {
        const {
            unreadMails, newBazaarEvents, newBazaarSell, wallStatusNews, isMobile, mobileShowLogo,
            headerHasBackBtn, headerTitle, headerLeft, headerRight, headerTabs,
            disableMobileHamburger, disableLogoLink, fluxibleCompatibility,
        } = this.props;

        return (
            <div className={styles.SiteMenu__header__content}>
                <Header
                    heading={headerTitle}
                    left={headerLeft}
                    right={headerRight}
                    isMobile={isMobile}
                    hasBackBtn={headerHasBackBtn}
                    notifications={unreadMails + newBazaarEvents + newBazaarSell + wallStatusNews}
                    showLogo={mobileShowLogo}
                    disableHamburger={disableMobileHamburger}
                    disableLogoLink={disableLogoLink}
                    fluxibleCompatibility={fluxibleCompatibility}
                />

                {headerTabs && headerTabs.length && (
                    <div className={styles.SiteMenu__header__tabs}>
                        {headerTabs.map((tab, index) => tab && (
                            <div key={index} className={styles.SiteMenu__header__tab}>{tab}</div>
                        ))}
                    </div>
                )}

                {this.renderToastr()}
            </div>
        );
    }

    public renderMobileMenu() {
        const {
            heartsCount, unreadMails, wishlistUpdates, newBazaarEvents, newBazaarSell, allBazaarSell, groupsCount,
            wallStatusNews, currentUrl, brandDaysCampaign, feedMenu, fluxibleCompatibility,
            requestUser, requestUserPermissions, menuSelection, subscribedCounsellings, showMergedForumAndGroups,
        } = this.props;

        let activeSection;
        let activeItem;
        if (menuSelection && menuSelection.activeSection) {
            activeSection = menuSelection.activeSection;
        }
        if (menuSelection && menuSelection.activeItem) {
            activeItem = menuSelection.activeItem;
        }

        return (
            <CSSTransition
                classNames={{
                    enter: styles['SiteMenu__mobileMenu--enter'],
                    enterActive: styles['SiteMenu__mobileMenu--enterActive'],
                    exit: styles['SiteMenu__mobileMenu--exit'],
                    exitActive: styles['SiteMenu__mobileMenu--exitActive'],
                }}
                in={this.state.mobileMenuOpened}
                mountOnEnter
                unmountOnExit
                timeout={300}
            >
                <div className={styles.SiteMenu__mobileMenu__content}>
                    <MobileMenu
                        requestUser={requestUser}
                        requestUserPermissions={requestUserPermissions}
                        fluxibleCompatibility={fluxibleCompatibility}
                        activeSection={activeSection}
                        activeItem={activeItem}
                        currentUrl={currentUrl}
                        heartsCount={heartsCount}
                        unreadMails={unreadMails}
                        newBazaarEvents={newBazaarEvents}
                        newBazaarSell={newBazaarSell}
                        allBazaarSell={allBazaarSell}
                        wallStatusNews={wallStatusNews}
                        wishlistUpdates={wishlistUpdates}
                        subscribedCounsellings={subscribedCounsellings}
                        groupsCount={groupsCount}
                        brandDaysCampaign={brandDaysCampaign}
                        feedMenu={feedMenu}
                        mergedForumAndGroups={showMergedForumAndGroups}
                        onItemClick={this.menuClose}
                        relocateWithNextParam={this.relocateWithNextParam}
                    />
                </div>
            </CSSTransition>
        );
    }

    public componentDidMount() {
        const { requestUser, requestUserPermissions, onFetchFlaggedCounts, disableJam } = this.props;

        // do not need to call onLoad(), initial data are passed from django via html
        // onLoad(requestUser.username);

        // fetch asynch count of flagged posts and groups
        const isBlogsAdmin = requestUserPermissions.indexOf('photoblog.can_manage_blogs') >= 0;
        const isForumAdmin = requestUserPermissions.indexOf('forum.can_manage_forum') >= 0;
        if (!disableJam && (isBlogsAdmin || isForumAdmin)) {
            onFetchFlaggedCounts();
        }

        if (!disableJam && isAuthenticated(requestUser)) {
            subscribeJam('userbar:' + requestUser.username);
        }
    }

    public componentWillUnmount() {
        const { requestUser, disableJam } = this.props;

        if (!disableJam && isAuthenticated(requestUser)) {
            unsubscribeJam('userbar:' + requestUser.username);
        }
    }

    private relocateWithNextParam = (thisHref) => {
        const { currentUrl } = this.props;

        if (!currentUrl) {
            return thisHref;
        }

        // remove ?qs from urls
        const currentPath = currentUrl.indexOf('?') > 0 ? currentUrl.substr(0, currentUrl.indexOf('?')) : currentUrl;
        const hrefPath = thisHref.indexOf('?') > 0 ? thisHref.substr(0, thisHref.indexOf('?')) : thisHref;

        if (currentPath === hrefPath) {
            return thisHref;
        } else {
            const hrefQS = thisHref.substring(hrefPath.length + 1);
            const qs = parse(hrefQS);
            qs.next = currentUrl;
            return `${hrefPath}?${stringify(qs)}`;
        }
    };

    private menuClose = () => {
        this.setState({
            mobileMenuOpened: false,
        });
        if (this.notificationMenu.current) {
            this.notificationMenu.current.close();
        }
    };

    private onMobileMenuChange = (event: React.FormEvent<HTMLInputElement>) => {
        this.setState({
            mobileMenuOpened: event.currentTarget.checked,
        });
    };
}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    const pageHeaderState = getPageHeaderState(state);
    const requestUser = getRequestUser(state);
    return {
        requestUser,
        requestUserPermissions: getRequestPermissions(state),
        isMobile: getRequestDeviceMobile(state),
        heartsCount: pageHeaderState.userData.heartsCount,
        unreadMails: pageHeaderState.userData.unreadMails,
        newBazaarEvents: pageHeaderState.userData.newBazaarEvents,
        newBazaarSell: pageHeaderState.userData.newBazaarSell,
        allBazaarSell: pageHeaderState.userData.allBazaarSell,
        wallStatusNews: pageHeaderState.userData.wallStatusNews,
        wishlistUpdates: pageHeaderState.userData.wishlistUpdates,
        subscribedCounsellings: pageHeaderState.userData.subscribedCounsellings,
        groupsCount: pageHeaderState.userData.groupsCount,
        brandDaysCampaign: pageHeaderState.brandDaysCampaign,
        feedMenu: pageHeaderState.feedMenu,
        privacyLeaflet: getRequestPrivacyLeaflet(state),
        showMergedForumAndGroups: ownProps.mergedForumAndGroups || hasMergedForumAndGroups(requestUser),
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
    onLoad: pageHeaderLoad,
    onFetchFlaggedCounts: pageHeaderFetchFlaggedCountsTrigger,
    onPrivacyLeafletAccept: privacyLeafletAcceptTrigger,
};

export default connect(mapStateToProps, mapDispatchToProps)(SiteMenu);

interface CompatibleLinkOwnProps {
    fluxibleCompatibility: boolean;
    to: string;
    className?: string;
    rel?: string;
    title?: string;
    onClick?();
}

export class CompatibleLink extends React.PureComponent<CompatibleLinkOwnProps> {
    public render() {
        const { to, onClick, className, fluxibleCompatibility, rel, title, children } = this.props;

        return fluxibleCompatibility ? (
            <a className={className} href={to} onClick={onClick} rel={rel} title={title}>{children}</a>
        ) : (
            <Link className={className} to={to} onClick={onClick} rel={rel} title={title}>{children}</Link>
        );
    }
}
